import Ingredient from "../../model/menudesign/Ingredient";

const apiUrl = process.env.REACT_APP_API_URL;
export const PostIngredient = async (page: string, ingredient: Ingredient, id_usu_log: string) => {
    try {
        const response = await fetch(`${apiUrl}:8072/ingredients/${id_usu_log}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(ingredient)
        });
        if (!response.ok) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};